// Real-time approach - returns current time
export const getCurrentTimestamp = () => {
  const now = new Date();
  
  const formatTime = (date) => {
    const months = date.getMonth() + 1;
    const days = date.getDate();
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12;
    hours = hours ? hours : 12; 
    
    return `${months.toString().padStart(2, '0')}-${days.toString().padStart(2, '0')}-${year} | ${hours}:${minutes}:${seconds} ${ampm}`;
  };
  
  return formatTime(now);
};

// Get current date without time
export const getCurrentDate = () => {
  const now = new Date();
  const months = now.getMonth() + 1;
  const days = now.getDate();
  const year = now.getFullYear();
  
  return `${months.toString().padStart(2, '0')}-${days.toString().padStart(2, '0')}-${year}`;
};

// Get last 3 days including today
export const getLast3Days = () => {
  const dates = [];
  for (let i = 2; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    
    const months = date.getMonth() + 1;
    const days = date.getDate();
    const year = date.getFullYear();
    
    dates.push({
      formatted: `${months.toString().padStart(2, '0')}-${days.toString().padStart(2, '0')}-${year}`,
      date: date,
      dayName: date.toLocaleDateString('en-US', { weekday: 'long' })
    });
  }
  return dates;
};

// Get date range string for display
export const getDateRangeString = () => {
  const dates = getLast3Days();
  const startDate = dates[0].formatted;
  const endDate = dates[2].formatted;
  return `${startDate} to ${endDate}`;
};

export const generateRecentTimestamp = () => {
  const now = new Date();
  const twentyFourHoursAgo = new Date(now.getTime() - (24 * 60 * 60 * 1000));
 
  const randomTime = new Date(twentyFourHoursAgo.getTime() + Math.random() * (now.getTime() - twentyFourHoursAgo.getTime()));
  
  const formatTime = (date) => {
    const months = date.getMonth() + 1;
    const days = date.getDate();
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12;
    hours = hours ? hours : 12; 
    
    return `${months.toString().padStart(2, '0')}-${days.toString().padStart(2, '0')}-${year} | ${hours}:${minutes} ${ampm}`;
  };
  
  return formatTime(randomTime);
};

export const generateRecentIsoTimestamp = () => {
  const now = new Date();
  const twentyFourHoursAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);

  // Pick a random time within the last 24h
  const randomTime = new Date(
    twentyFourHoursAgo.getTime() +
      Math.random() * (now.getTime() - twentyFourHoursAgo.getTime())
  );

  const formatTime = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };

  return formatTime(randomTime);
};
